import { FaClock, FaRunning, FaDumbbell, FaChevronCircleLeft, FaChevronCircleRight, FaRectangleList, FaRedoAlt, FaRegCheckCircle } from "react-icons/fa";
import { BsFillPlusCircleFill, BsFillEyeFill, BsFillEyeSlashFill, BsFillEnvelopeFill, BsXCircleFill } from "react-icons/bs";
import { AiOutlineUnorderedList } from "react-icons/ai";
import { TbReplace } from "react-icons/tb";
import { RiHeartFill } from "react-icons/ri";
import "./style.css";


export const Check = (props) => {
    return <FaRegCheckCircle className="c-icon" {...props} />;
}

export const Clock = () => {
    return <FaClock className="c-icon" />;
}

export const Plus = () => {
    return <BsFillPlusCircleFill className="c-icon" />;
}

export const Running = () => {
    return <FaRunning className="c-icon" />;
}

export const RectangleList = () => {
    return <AiOutlineUnorderedList className="c-icon" />;
}

export const Dumbbell = () => {
    return <FaDumbbell className="c-icon" />;
}

export const FillEye = (props) => {
    return <BsFillEyeFill {...props} className="c-icon" />;
}

export const FillEyeSlash = (props) => {
    return <BsFillEyeSlashFill {...props} className="c-icon" />;
}

export const Email = () => {
    return <BsFillEnvelopeFill className="c-icon" />;
}

export const Back = (props) => {
    return <FaChevronCircleLeft className="c-icon" {...props} />;
}

export const Forward = (props) => {
    return <FaChevronCircleRight className="c-icon" {...props} />;
}

export const Restart = () => {
    return <FaRedoAlt className="c-icon" />;
}

export const Replace = () => {
    return <TbReplace className="c-icon" />;
}

export const Close = ({ withBG = true }) => {
    return <div style={withBG ? { backgroundColor: "#fff" } : {}}>
        <BsXCircleFill className="c-icon" />
    </div>;
}

export const Heart = (props) => {
    const { } = props;

    return <RiHeartFill className="c-icon" {...props} />;
}



